module.exports = __webpack_public_path__ + "static/servicePublishing-45fd308cf9eb86dbbe8a787a20d968ba.png";